import { Link } from "react-router-dom";

export default function ItinAssistance() {
    return (
        <>
            {/* Spacer for sticky header */}
            <div /> {/* Header spacing style={{ height: 72 }}*/}

            {/* Hero Banner */}
            <section className="py-5 text-center">
                <div className="container">
                    <h1
                        className="display-5 fw-bold mb-3"
                        style={{
                            fontFamily: "'Poppins', sans-serif",
                            background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                            color: "transparent",
                            WebkitBackgroundClip: "text",
                            backgroundClip: "text",
                            lineHeight: 1.1,
                        }}
                    >Our ITIN Assistance Services</h1>

                    <p
                        className="text-muted fs-5 mx-auto"
                        style={{ maxWidth: 600 }}
                    >
                        Comprehensive ITIN application and renewal support tailored to your tax planning needs. Trust our experts to guide you smoothly through the IRS requirements.
                    </p>

                </div>
            </section>

            <section className="py-5 bg-light">
                <div className="container">
                    <div className="row g-4 justify-content-center">
                        {[
                            {
                                title: "ITIN Application",
                                description: "Help with completing and submitting Form W-7 to apply for an ITIN.",
                                icon: "bi bi-file-earmark-text",
                                bgColor: "#f2e6fa",
                                iconColor: "#6B46C1",
                            },
                            {
                                title: "ITIN Renewal",
                                description: "Assistance with renewing an expired ITIN, ensuring compliance with IRS requirements.",
                                icon: "bi bi-arrow-clockwise",
                                bgColor: "#fde6e9",
                                iconColor: "#D53F8C",
                            },
                            {
                                title: "Consultation",
                                description: "Guidance on whether you need an ITIN and how it fits into your tax planning strategy.",
                                icon: "bi bi-chat-dots",
                                bgColor: "#e0f0ff",
                                iconColor: "#224eae",
                            },
                            {
                                title: "Filing Support",
                                description: "Preparation and filing assistance for tax returns using ITIN.",
                                icon: "bi bi-file-earmark-check",
                                bgColor: "#e8f5e9",
                                iconColor: "#31926A",
                            },
                        ].map(({ title, description, icon, bgColor, iconColor }) => (
                            <div className="col-md-6 col-lg-3" key={title}>
                                <div className="card h-100 border-0 shadow p-4 text-center rounded-4">
                                    <span
                                        className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-60"
                                        style={{ background: bgColor, margin: "0 auto" }}
                                    >
                                        <i className={`${icon} fs-2`} style={{ color: iconColor }}></i>
                                    </span>
                                    <h5 className="fw-semibold mb-2" style={{ color: iconColor }}>
                                        {title}
                                    </h5>
                                    <p className="small text-secondary">{description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Informative Section */}
            <section className="py-5 bg-white">
                <div className="container" style={{ maxWidth: 900 }}>
                    <p className="text-secondary fs-5 mb-4">
                        Navigating the ITIN application process can be complex. Our team of tax professionals is here to make the process simple and efficient.
                        Whether you're applying for an ITIN for the first time or need assistance with renewal, we ensure that you meet all IRS requirements and avoid potential delays.
                    </p>
                    <p className="text-secondary fs-5 mb-0">
                        Contact us today to learn how we can help you obtain or renew your ITIN and ensure your tax compliance is smooth and hassle-free.
                    </p>
                </div>
            </section>

            {/* IRS Office Locator Section */}
            <section className="py-5" style={{ background: "linear-gradient(135deg, #f8f9ff 0%, #fff5fb 100%)" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                                <div className="card-body p-5">
                                    <div className="row align-items-center">
                                        <div className="col-md-8">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    background: "linear-gradient(135deg, #3B82F6, #2563EB)",
                                                    color: "#fff"
                                                }}>
                                                    <i className="bi bi-geo-alt-fill fs-3"></i>
                                                </div>
                                                <h2 className="fw-bold mb-0" style={{
                                                    fontFamily: "'Poppins', sans-serif",
                                                    color: "#2e3d9c",
                                                    fontSize: "2rem"
                                                }}>
                                                    Find Your Local IRS Office
                                                </h2>
                                            </div>
                                            <p className="fs-5 text-secondary mb-4" style={{ lineHeight: "1.8" }}>
                                                Need to visit an IRS office in person or find state-specific tax information? Use the official IRS Office Locator to find the nearest Taxpayer Assistance Center in your area. This tool helps you locate IRS offices where you can get in-person help with your ITIN application, tax questions, and other tax-related services.
                                            </p>
                                            <p className="fs-6 text-secondary mb-4" style={{ lineHeight: "1.7" }}>
                                                <strong>What you can do:</strong> Search by your address, city, state, or ZIP code to find the closest IRS office. You can also view office hours, services available, and get directions to help you plan your visit.
                                            </p>
                                            <a
                                                href="https://apps.irs.gov/app/office-locator/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3 d-inline-flex align-items-center"
                                                style={{
                                                    background: "linear-gradient(135deg, #3B82F6, #2563EB)",
                                                    boxShadow: "0 4px 15px rgba(37, 99, 235, 0.4)",
                                                    transition: "all 0.3s ease",
                                                    border: "none"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = "scale(1.05)";
                                                    e.currentTarget.style.boxShadow = "0 8px 30px rgba(37, 99, 235, 0.6)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = "scale(1)";
                                                    e.currentTarget.style.boxShadow = "0 4px 15px rgba(37, 99, 235, 0.4)";
                                                }}
                                            >
                                                <i className="bi bi-box-arrow-up-right me-2"></i>
                                                Visit IRS Office Locator
                                            </a>
                                        </div>
                                        <div className="col-md-4 text-center mt-4 mt-md-0">
                                            <div className="p-4" style={{
                                                background: "linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(37, 99, 235, 0.1))",
                                                borderRadius: "1rem"
                                            }}>
                                                <i className="bi bi-building fs-1 mb-3" style={{ color: "#3B82F6" }}></i>
                                                <p className="small text-secondary mb-0">
                                                    Official IRS Resource
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            {/* Simple Call to Action */}
            <section className="py-5 bg-light text-center">
                <div className="container">
                    <h2 className="fw-bold mb-3" style={{
                        fontFamily: "'Poppins',sans-serif",
                        color: "#2e3d9c"
                    }}>Need Expert ITIN Assistance?</h2>
                    <p className="fs-5 mb-4 text-secondary" style={{ maxWidth: 540, margin: "0 auto" }}>
                        Connect with Nexen Consulting’s tax professionals today to make your ITIN application or renewal process effortless.
                    </p>
                    <div className="d-flex justify-content-center">
                        <Link
                            to="/contact"
                            className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
                            style={{
                                background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                                boxShadow: '0 4px 15px rgba(213,63,140,0.45)',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.transform = 'scale(1.05)';
                                e.currentTarget.style.boxShadow = '0 8px 30px rgba(213,63,140,0.7)';
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(213,63,140,0.45)';
                            }}
                        >
                            Get In Touch
                        </Link>
                    </div>
                </div>
            </section>

            {/* Bootstrap Icons CDN if needed */}
            <link
                rel="stylesheet"
                href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
            />
        </>
    );
}
